module.exports = __webpack_public_path__ + "static/media/dm_world.ca3b0031.svg";